<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['userInfo','openid'])
		},
		onLaunch: function() {
			var that = this;
			if (!this.openid || this.openid =='') {
				uni.login({
					provider: 'weixin',
					success: async function (loginRes) {
						let { code } = loginRes;
						let res = await that.$u.api.wxLogin({ code })
						if (res&& res.code === 200) {
							that.$store.commit('setToken', res.data.token)
							that.$store.commit('setOpenid', res.data.openid)
							that.$store.commit('setUserInfo', res.data.member)
							that.$isResolve()
						}
					}
				});
			} 
		},
		onShow: function() {
			console.log('App Show')
			var that =this
			let res =  this.$u.api.getMemberInfo({}).then(res =>{ 
				if (res && res.code ===200) { 
					that.$store.commit('setUserInfo', res.data)
					that.$isResolve()
				}else{
					that.$store.commit('setToken','')
					that.$store.commit('setUserInfo',{})
					that.$isResolve()
				}
			})
			
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	@import "uview-ui/index.scss"; 
</style>